import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { Game } from '../../../Core'

import UIButton from '../../UI/UIButton'

const showSettingsMenu = ({ addPopup }) => {
  addPopup('settings_menu')
}

/**
 *  Setting button on UI.
 */
const SettingsMenuButton = ({ addPopup }) => (
  <UIButton
    id="settings_menu"
    icon="icon-nav"
    position="position--absolute right top z-index1"
    action={() => showSettingsMenu({ addPopup })}
  />
)

const mapDispatchToProps = (dispatch) => ({
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
})

SettingsMenuButton.propTypes = {
  addPopup: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(SettingsMenuButton)
